
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/productos/tematica/[slug]",
      function () {
        return require("private-next-pages/productos/tematica/[slug]/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/productos/tematica/[slug]"])
      });
    }
  